<ngx-spinner bdOpacity=0.5 bdColor="rgba(0,0,0,0.84)" size="default" color="#fff" type="ball-pulse"
[fullScreen]="true"> </ngx-spinner>
<div class="col-12 site-banner pl-0 pr-0">
    <!---------------Single Banner------------------>
    <div class="single-pageBanner">
        <div class="single-image-Banner news-banner">
            <img src="assets/images/podcasts/Popular-podcasts/podcast-news-Banner.jpg" alt="podcast-news-Banner">
        </div>
        <div class="singleCaption">
            <div class="container">
                <h1>Podcast <span>News</span></h1>
            </div>
        </div>
    </div>
    <!---------------END Single Banner------------------>
</div>

<section>
    <div class="wrapper">
        <div class="col-12 newsPodcasts-section greenlight-bg px-100">
            <div class="row">
                <div class="container">
                    <div class="row">
                        <div class="col-12 newsList">
                            <div class="graphics-shape-tnews1">
                                <img src="assets/images/podcasts/Popular-podcasts/shape-t4.png" alt="shape-t4">
                            </div>
                            <div class="graphics-shape-tnews2">
                                <img src="assets/images/podcasts/Popular-podcasts/shape-t5.png" alt="shape-t5">
                            </div>
                            <div class="graphics-shape-tnews3">
                                <img src="assets/images/podcasts/Popular-podcasts/shape-t5.png" alt="shape-t5">
                            </div>
                            <div class="graphics-shape-tnews4">
                                <img src="assets/images/podcasts/Popular-podcasts/shape-t4.png" alt="shape-t4">
                            </div>
                            <div class="graphics-shape-tnews5">
                                <img src="assets/images/podcasts/Popular-podcasts/shape-t5.png" alt="shape-t5">
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4 news-item" *ngFor="let news of podcastNewsList">
                                    <div class="news-inner">
                                        <div class="thumb-image">
                                            <img  [src]="news?.field_image_url_value" alt="{{news?.title}}">
                                        </div>
                                        <div class="thumb-content">
                                            <span class="date">{{news?.created | date:'MMMM dd, y'}}</span>
                                            <h4>{{news?.title}}</h4>
                                            <div [innerHtml]="news?.description | podcastSanitizeHtml">
                                                
                                            </div>
                                            <p><a href="{{news?.full_url}}" target="_blank">Read More</a></p>
                                            <!-- <span class="date">August 15, 2023</span>
                                            <h4>People are podcasting all over the world</h4>
                                            <p>Hayti (pronounced "HAY-tie") is the name of the historic African-American community that is now part of the city of Durham, NC. African-Americans named the community <a href="#">Read More</a></p> -->
                                        </div>
                                    </div>
                                </div>
                              
                            </div>
                            <div class="row" *ngIf="totalPages != page">
                                <ng-container *ngIf="totalPages >= page">
                                <div class="col-12 mt-4 text-center">
                                    <!-- <a href="javascript:void(0);" class="btn btn-green" (click)="viewMore((pager?.currentPage*1) + (1*1))">View More</a> -->
                                    <a href="javascript:void(0);" class="btn btn-green" (click)="viewMore()">View More</a>
                                </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>